import React, { useState, useEffect } from "react";
import { Formik } from "formik";
import {
  Collapse,
  Button,
  Input,
  Select,
  Form,
  Row,
  Col,
  Space,
  Alert,
  Pagination,
  Dropdown,
  Menu,
} from "antd";
import { Popconfirm } from "antd";

import { Card, Checkbox, Divider, Typography } from "antd";
import { CaretRightOutlined } from "@ant-design/icons";

import { ToastContainer, toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import Loadar from "../../../../common/loader/Loader";
import MultiSelect from "./MultiSelect";
import "./ChargeSettings.css";
import {
  getPayoutChargeDetails,
  getchargesSettings,
  updateCharges,
  updateDmt,
  updatePayout,
  updateAeps,
  getdmtchargesSettings,
  getsetPayoutData,
  getDmtData,
  getaepsVendorService,
  getaepsVendorServiceupdate,
  getaepsVendorList,
  aepsVendorupdate,
  getActiveaepsVendorList,
  getbbpsServiceList,
  updatebbpsSetting,
  getbbpsSettingList,
  addbbpsSetting,
  getcourierSettingList,
  addcourierSettingApi,
  updatecourierSettingApi,
  deletecourierSettingApi,
  getPayoutUserList,
  getPayoutVendorList,
  addupdatePayoutVendorSetting,
  getPayoutSettingList,
} from "../../../../api/login/Login";
import AEPSSettings from "./Aepsettings";
import { useMemo } from "react";

const { Panel } = Collapse;
const { Option } = Select;
const { Title, Text } = Typography;

function ChargeSettings() {
  const [loading, setLoading] = useState(false);
     const [payoutSettingCurrentPage , setPayoutSettingCurrentPage] = useState(1)
  const [activeKey, setActiveKey] = useState(["charges"]);
  const [currentKey, setCurrentKey] = useState("charges");
  const token = window.localStorage.getItem("userToken");
  const [bbpsPage, setBbpsPage] = useState(0);
  const [bbpsListData, setBbpsListData] = useState([]);
  const [courierSettingListData, setCourierSettingListData] = useState([]);
  const [opencourierSetting, setOpencourierSetting] = useState(false);
  const [openModel, setOpenModel] = useState(false);
  const [bbpsSettingList, setbbpsSettingList] = useState();
  const [bbpsSettingEditClick, setbbpsSettingEditClick] = useState(false);
  const [courierSettingEditClick, setcourierSettingEditClick] = useState(false);
  const [selectedCourierSettingObj , setselectedCourierObj] = useState()
  const [bbpsSettingSelectedKey, setBbpsSettingSelectedKey] = useState(""); 
  const [addcourierSetting, setcourierSetting] = useState({
    vendor: "",
    slug: "",
    status:'',
    is_default : false,
  });
  const [bbpsSettingFilter, setBBpsSettingFilter] = useState({
    vendor_slug: "",
    service_name: "",
  });



  const [chargeData, setChargeData] = useState({
    bankVerificationCharge: "",
    aeps_onBoardingCharge: "",
    minAepsToMainWallet: "",
    courier_charges:"",
    courier_order_charges :"",
    courier_cashback :"",
  });

  const [dmtData, setDmtData] = useState({
    dmtOptions: [],
    dmtApiType: [],
    defaultApi: "",
  });

  const [aepsData2, setAeps2] = useState({
    dmtOptions: [],
    dmtApiType: [],
    defaultApi: "",
  });

  const [aepsData4, setAeps4] = useState({
    dmtOptions: [],
    dmtApiType: [],
    defaultApi: "",
  });

  const [payoutData, setPayoutData] = useState({
    payoutOptions: [],
    payoutApi: [],
    defaultPayoutApi: "",
  });

  const [aepsData, setAepsData] = useState({
    aeps_onBoardingDefaultBank: "",
  });

  const [reset, setReset] = useState(false);


  const toastSuccessMessage = (message) => {
    toast.success(message, { position: "top-center" });
  };

  const toastErrorMessage = (message) => {
    toast.error(message, { position: "top-center" });
  };

  const handleCollapseChange = (keys) => {
    console.log(keys , "key")
    // setActiveKey(keys);
    keys.forEach((key) => {
      if (!activeKey.includes(key)) {
        // fetchSectionData(key);
        setActiveKey([key]);
        setCurrentKey(key);
      }
    });
  };

  const fetchSectionData = async (section) => {
    setLoading(true);
    try {
      switch (section) {
        case "charges":
          const chargeResponse = await getchargesSettings({ token });
          if (chargeResponse?.data) {
            setChargeData(chargeResponse.data);
          }
          break;

        case "dmt":
          const dmtResponse = await getDmtData({ token });
          if (
            dmtResponse?.statusCode === "200" &&
            dmtResponse.data &&
            dmtResponse.data.length > 0
          ) {
            const dmtSettingsData = dmtResponse.data[0];
            const dmtApiResponse = await getdmtchargesSettings({ token });
            if (dmtApiResponse?.data && Array.isArray(dmtApiResponse.data)) {
              const dmtOptions = dmtApiResponse.data.map((item) => ({
                id: item?._id,
                value: item?.slug,
                label: item?.name,
              }));
              dmtOptions.unshift({ value: "selectAll", label: "Select All" });
              setDmtData((prevState) => ({
                ...prevState,
                dmtOptions,
                dmtApiType: dmtSettingsData.dmtApiType || [],
                defaultApi: dmtSettingsData.defaultApi || "",
              }));
            }
          }
          break;

        case "payout":
          const payoutResponse = await getsetPayoutData({ token });
          if (
            payoutResponse?.statusCode === "200" &&
            payoutResponse.data &&
            payoutResponse.data.length > 0
          ) {
            const payoutSettingsData = payoutResponse.data[0];
            const payoutApiResponse = await getPayoutChargeDetails({ token });
            if (
              payoutApiResponse?.data &&
              Array.isArray(payoutApiResponse.data)
            ) {
              const payoutOptions = payoutApiResponse.data.map((item) => ({
                id: item?._id,
                value: item?.slug,
                label: item?.vender_name,
              }));
              payoutOptions.unshift({
                value: "selectAll",
                label: "Select All",
              });
              setPayoutData((prevState) => ({
                ...prevState,
                payoutOptions,
                payoutApi: payoutSettingsData.payoutApi || [],
                defaultPayoutApi: payoutSettingsData.defaultPayoutApi || "",
              }));
            }
          }
          break;
        
        case "new_payout": 
        fetchPayoutVendorListAndPayoutUserList()
        break;
        // case 'aeps':
        //   const aepsResponse = await getchargesSettings({ token });
        //   if (aepsResponse?.data) {
        //     setAepsData({
        //       aeps_onBoardingDefaultBank: aepsResponse.data.aeps_onBoardingDefaultBank || '',
        //     });
        //   }
        //   break;

        case "aeps2":
          const aepsBank2 = await getaepsVendorService(token, "aeps1");
          const aepsBank4 = await getaepsVendorService(token, "aeps2");
          const aepsVendorList = await getaepsVendorList(token);
          const activeVenderList = await getActiveaepsVendorList();
          console.log(activeVenderList, "aeps");
          if (aepsVendorList?.statusCode === 200) {
            const newData = aepsVendorList?.data?.map((service) => ({
              id: service._id,
              label: service.vender,
              value: service.slug, // Using slug as value
            }));
            const se = {
              id: "selectAll",
              label: "Select All",
              value: "selectAll",
            };
            newData.unshift(se);
            setAepsbank(newData);
            const activeServiceIds = activeVenderList?.data?.aepsApi.map(
              (item) => item._id
            );
            setAepsbankSelectedIds(activeServiceIds || []);
            setActiveBankService(activeVenderList?.data?.aepsApi || []);
            setAepsbankDefault(activeVenderList?.data?.defaultAepsApi);
          }

          if (aepsBank2?.statusCode === 200) {
            const newData = aepsBank2?.data?.serviceList?.map((service) => ({
              id: service._id,
              label: service.service_name,
              value: service._id, // Using slug as value
            }));
            const se = {
              id: "selectAll",
              label: "Select All",
              value: "selectAll",
            };
            newData.unshift(se);
            setSelectedIdsAEPS2(newData);
            const activeServiceIds = aepsBank2?.data?.activeService;
            setSelectedIds(activeServiceIds || []);
          }
          if (aepsBank4?.statusCode === 200) {
            const newData = aepsBank4?.data?.serviceList?.map((service) => ({
              id: service._id,
              label: service.service_name,
              value: service._id, // Using slug as value
            }));
            const se = {
              id: "selectAll",
              label: "Select All",
              value: "selectAll",
            };
            newData.unshift(se);
            setSelectedIdsAEPS4(newData);
            const activeServiceIds = aepsBank4?.data?.activeService;
            setSelectedIds4(activeServiceIds || []);
          }
          break;

        case "bbps":
          let obj = {
            vendor_slug: bbpsSettingFilter.vendor_slug,
            service_name: bbpsSettingFilter.service_name,
            page: bbpsPage,
          };
          let response = await getbbpsServiceList(obj);
          let bbpssettingList = await getbbpsSettingList();
          setbbpsSettingList(bbpssettingList?.data);
          setBbpsListData(response?.data);

          break;
        
        case 'courier':  
            let couriersetting = await getcourierSettingList()
            setCourierSettingListData(couriersetting?.data)
          break;
        default:
          break;
      }
    } catch (error) {
      console.error(`Error fetching ${section} data:`, error);
      toastErrorMessage(`Error fetching ${section} data`);
    } finally {
      setLoading(false);
    }
  };

  const handleChargesUpdate = async (values) => {
    try {
      setLoading(true);
      const numericValues = {
        aeps_onBoardingCharge: Number(values.aeps_onBoardingCharge),
        bankVerificationCharge: Number(values.bankVerificationCharge),
        minAepsToMainWallet: Number(values.minAepsToMainWallet),
        courier_charges:Number(values.courier_charges),
        courier_order_charges : Number(values.courier_order_charges),
        courier_cashback :Number(values.courier_cashback),
      };
      console.log("Updating charges with values:", numericValues);
      const response = await updateCharges(numericValues);
      console.log("Updating charges response:", response);
      if (response?.data?.statusCode == "200") {
        toastSuccessMessage(
          response?.data?.message || "Charges updated successfully"
        );
        setChargeData(response.data.data);
      } else {
        toastErrorMessage(response.message || "Error updating charges");
      }
    } catch (error) {
      console.error("Error updating charges:", error);
      toastErrorMessage("Error updating charges");
    } finally {
      setLoading(false);
    }
  };

  const handleDmtUpdate = async () => {
    try {
      setLoading(true);
      const updatedValues = {
        dmtApiType: dmtData.dmtApiType,
        defaultApi: dmtData.defaultApi,
      };
      const response = await updateDmt(updatedValues);
      if (response?.statusCode === "200") {
        toastSuccessMessage(
          response.message || "DMT settings updated successfully"
        );
      } else {
        toastErrorMessage(response.message || "Error updating DMT settings");
      }
    } catch (error) {
      console.error("Error updating DMT settings:", error);
      toastErrorMessage("Error updating DMT settings");
    } finally {
      setLoading(false);
    }
  };

  const handlePayoutUpdate = async () => {
    try {
      setLoading(true);
      const updatedValues = {
        payoutApi: payoutData.payoutApi,
        defaultPayoutApi: payoutData.defaultPayoutApi,
      };
      console.log("Updating Payout settings with values:", updatedValues);
      const response = await updatePayout(updatedValues);
      if (response?.statusCode === "200") {
        toastSuccessMessage(
          response.message || "Payout settings updated successfully"
        );
      } else {
        toastErrorMessage(response.message || "Error updating Payout settings");
      }
    } catch (error) {
      console.error("Error updating Payout settings:", error);
      toastErrorMessage("Error updating Payout settings");
    } finally {
      setLoading(false);
    }
  };

  const handleAepsUpdate = async () => {
    try {
      setLoading(true);
      console.log("Updating AEPS settings with values:", aepsData);
      const response = await updateAeps(aepsData);
      if (response?.statusCode === "200") {
        toastSuccessMessage(
          response.message || "AEPS settings updated successfully"
        );
      } else {
        toastErrorMessage(response.message || "Error updating AEPS settings");
      }
    } catch (error) {
      console.error("Error updating AEPS settings:", error);
      toastErrorMessage("Error updating AEPS settings");
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setChargeData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const styles = {
    container: {
      maxWidth: "1200px",
      margin: "0 auto",
      padding: "20px",
      fontFamily: "Arial, sans-serif",
    },
    panel: {
      backgroundColor: "#f7f7f7",
      borderRadius: "8px",
      marginBottom: "20px",
    },
    panelHeader: {
      fontSize: "18px",
      fontWeight: "bold",
      color: "#333",
    },
    form: {
      padding: "20px",
    },
    formItem: {
      marginBottom: "20px",
    },
    input: {
      width: "100%",
      padding: "8px",
      borderRadius: "4px",
      border: "1px solid #d9d9d9",
    },
    button: {
      backgroundColor: "#1890ff",
      color: "white",
      border: "none",
      padding: "10px 20px",
      borderRadius: "4px",
      cursor: "pointer",
      fontSize: "16px",
      transition: "background-color 0.3s",
    },
    buttonDisabled: {
      backgroundColor: "#bfbfbf",
      cursor: "not-allowed",
    },
  };

  // Pre-selected service IDs

  const [SelectedIdAEPS2, setSelectedIdsAEPS2] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [defaultApi, setDefaultApi] = useState(selectedIds[0] || "");

  const [SelectedIdAEPS4, setSelectedIdsAEPS4] = useState([]);
  const [selectedIds4, setSelectedIds4] = useState([]);
  const [defaultApi4, setDefaultApi4] = useState(selectedIds4[0] || "");

  const [aepsbank, setAepsbank] = useState([]);
  const [aepsbankselectedIds, setAepsbankSelectedIds] = useState([]);
  const [aepsbankdefault, setAepsbankDefault] = useState("");
  const [activeBankService, setActiveBankService] = useState([]);

  // setSelectedIdsAEPS2(()=>data1?.serviceList?.activeService)

  //BBps

  const [selectedBBPSService, setSelectedBBPSService] = useState("");
  const [selectedBBPSVendor, setSelectedBBPSVendor] = useState("");

  const handleUpdateAepsSetting = async () => {
    let obj = {
      aeps2Services: selectedIds,
      aeps4Services: selectedIds4,
    };

    try {
      setLoading(true);
      const response = await getaepsVendorServiceupdate(token, obj);
      if (response?.statusCode === 200) {
        toastSuccessMessage(
          response.message || "AEPS settings updated successfully"
        );
      } else {
        toastErrorMessage(response.message || "Error updating AEPS settings");
      }
    } catch (error) {
      console.error("Error updating AEPS settings:", error);
      toastErrorMessage("Error updating AEPS settings");
    } finally {
      setLoading(false);
      setReset((pre) => !pre);
    }
  };

  const handlebankupdateStatus = async () => {
    let obj = {
      aepsApi: aepsbankselectedIds,
      defaultAepsApi: aepsbankdefault,
    };

    try {
      setLoading(true);
      const response = await aepsVendorupdate(token, obj);
      if (response?.statusCode === 200) {
        toastSuccessMessage(
          response.message || "AEPS settings updated successfully"
        );
      } else {
        toastErrorMessage(response.message || "Error updating AEPS settings");
      }
    } catch (error) {
      console.error("Error updating AEPS settings:", error);
      toastErrorMessage("Error updating AEPS settings");
    } finally {
      setLoading(false);
      setReset((pre) => !pre);
    }
  };

  useEffect(() => {
    // fetchSectionData('charges');
    // fetchSectionData('dmt');
    // fetchSectionData('payout');
    fetchSectionData(currentKey);
  }, [currentKey, reset, bbpsPage , payoutSettingCurrentPage]);

  const handleClickBBPSEdit = (id, serviceId, vendorId) => {
    setOpenModel(true);
    setBbpsSettingSelectedKey(id);
    setSelectedBBPSService(serviceId);
    setSelectedBBPSVendor(vendorId);
    setbbpsSettingEditClick(true);
  };



  const selectedServiceforVendor = useMemo(
    () => bbpsSettingList?.find((item) => item?._id === selectedBBPSService),
    [selectedBBPSService]
  );

  const handleSelectService = (value) => {
    setSelectedBBPSService(value);
    setSelectedBBPSVendor("");
  };

  const handleBBpsSettingPopupClose = () => {
    setSelectedBBPSService("");
    setSelectedBBPSVendor("");
    setOpenModel(false);
    setbbpsSettingEditClick(false);
    setBbpsSettingSelectedKey("");
  };

  const hanldeBBPSsettingAddEdit = async () => {
    let obj = {
      service_id: selectedBBPSService,
      vendor_id: selectedBBPSVendor,
    };
    if (bbpsSettingSelectedKey) {
      obj.id = bbpsSettingSelectedKey;
    }
    try {
      setLoading(true);
      let response;
      bbpsSettingEditClick
        ? (response = await updatebbpsSetting(obj))
        : (response = await addbbpsSetting(obj));

      if (response?.statusCode === 200) {
        toastSuccessMessage(response.message);
      } else {
        toastErrorMessage(response.message);
      }
    } catch (error) {
      console.error("Error during action BBPS settings:", error);
      toastErrorMessage("Error during action BBPS settings");
    } finally {
      setLoading(false);
      handleBBpsSettingPopupClose();
      setReset((pre) => !pre);
    }
  };
  const handleFilterChange = (e) => {
    const { name, value } = e.target;

    setBBpsSettingFilter((prevState) => ({
      ...prevState, // Spread the previous state
      [name]: value, // Add/Update the property with the new name and value
    }));
  };

  const applyFilter = () => {
    setBbpsPage(0);
    setReset((pre) => !pre);
  };

  const handleReset = () => {
    setBBpsSettingFilter({ service_name: "", vendor_slug: "" });
    setBbpsPage(0);
    setReset((pre) => !pre);
  };

  const handleaddCourierSetting = (e) => {
    const { name, value } = e.target;

    setcourierSetting((prevState) => ({
      ...prevState, 
      [name]: value, 
    }));
  };

  const handleCourierSettingPopupClose = () => {
    
    setOpencourierSetting(false);
    setcourierSettingEditClick(false)
    setselectedCourierObj(null)
    setcourierSetting({
      vendor: '',
      slug: '',
      status:'',
      is_default : false,
  })
    // setbbpsSettingEditClick(false);
  };

  const hanldeCouriersettingAddEdit = async()=>{
  
      if(addcourierSetting.vendor.trim() ==='' || addcourierSetting.slug.trim()==='' )
      {
        alert("All Filed is Required")
        return
      }
   
    try {
      setLoading(true);
      let response;
      courierSettingEditClick
        ? (response = await updatecourierSettingApi(addcourierSetting , selectedCourierSettingObj?._id))
        : (response = await addcourierSettingApi(addcourierSetting));

      if (response?.statusCode === 200) {
        toastSuccessMessage(response.message);
      } else {
        toastErrorMessage(response.message);
      }
    } catch (error) {
      console.error("Error during action BBPS settings:", error);
      toastErrorMessage("Error during action BBPS settings");
    } finally {
      setLoading(false);
      handleCourierSettingPopupClose();
      setReset((pre) => !pre);
    }
  }

  const handleDeleteCourierSetting = async(item)=> {
 
    setLoading(true);
    try {
      let response = await deletecourierSettingApi(item?._id)
      if (response?.statusCode === 200) {
        toastSuccessMessage(response.message);
      } else {
        toastErrorMessage(response.message);
      }
    } catch (error) {
      
    }finally{
      setLoading(false);
      setReset((pre) => !pre);
    }
  }


  /**  start payout all new things start here 
   * **/
   const [openPayoutModel , setOpenPayoutModel] = useState(false)

   const [payoutVendorList , setPayVendorList] = useState([])
    const [payoutSettingList , setPaySettingList] = useState([])
   const [payoutUserList , setPayoutUserList] = useState([])
   const [selectedPayoutVendor , setSelectedPayoutVendor] = useState('')
   const [selectedPayoutUser , setSelectedPayoutUser] = useState('')
   const [currentSelectedpayoutList , setCurrentSelectedpayoutList] = useState('')

const fetchPayoutVendorListAndPayoutUserList = async () => {
  try {
    let [vendorList, userList , settingList] = await Promise.all([
      getPayoutVendorList(),
      getPayoutUserList(),
      getPayoutSettingList({page:payoutSettingCurrentPage})
    ])
    setPayVendorList(vendorList?.data || [])
    setPayoutUserList(userList?.data ||[])
    setPaySettingList(settingList || [])
  } catch (error) {
  
  }
}




const handleAddUpdatePayoutSetting = async () => {

    let body = {
      user_id : selectedPayoutUser,
      vender_id : selectedPayoutVendor
    }
    setLoading(true)
     try {
      let res = await addupdatePayoutVendorSetting(body)
      if(res?.error === false)
      {
        toastSuccessMessage(res?.message)
        handleClosePayoutModel()
      }
      else {
        toastErrorMessage(res?.message)
      }
     } catch (error) {
      
     } finally{
        setLoading(false)
      setReset((pre) => !pre);
     }
}

   const [payoutForm] = Form.useForm();

   const handleEditClick = (value) => {
  setOpenPayoutModel(true);

  const userId = value?.user_id || payoutUserList.find((v) => v.mobile === value.user_mobile)?._id;
  const vendorId = value?.vender_id || payoutVendorList.find((v) => v.slug === value.vender_slug)?._id;

  setSelectedPayoutUser(userId);
  setSelectedPayoutVendor(vendorId);
  setCurrentSelectedpayoutList(value?._id);

  // ✅ Set values inside the AntD Form
  payoutForm.setFieldsValue({
    user_name: userId,
    vendor_name: vendorId,
  });
};

const handleClosePayoutModel = ()=>{
  setOpenPayoutModel(false)
  setSelectedPayoutUser('')
  setCurrentSelectedpayoutList('')
  setSelectedPayoutVendor('') 
    payoutForm.setFieldsValue({
    user_name: '',
    vendor_name: '',
  });
}
   /**  start payout all new things start end here 
   * **/

  return (
    <>
      <div style={styles.container}>
        {loading && <Loadar />}
        <Collapse
          expandIcon={({ isActive }) => (
            <CaretRightOutlined rotate={isActive ? 90 : 0} />
          )}
          onChange={handleCollapseChange}
          activeKey={activeKey}
        >
          <Panel
            header={<span style={styles.panelHeader}>Charges</span>}
            key="charges"
            style={styles.panel}
          >
            {Object.keys(chargeData).length > 0 && (
              <Formik
                initialValues={chargeData}
                onSubmit={handleChargesUpdate}
                enableReinitialize
              >
                {({ values, handleSubmit }) => (
                  <Form
                    onFinish={handleSubmit}
                    layout="vertical"
                    style={styles.form}
                  >
                    <Row gutter={16}>
                      <Col span={8}>
                        <Form.Item
                          label="Account Verification Charge"
                          style={styles.formItem}
                        >
                          <Input
                            type="number"
                            name="bankVerificationCharge"
                            value={values.bankVerificationCharge}
                            onChange={handleInputChange}
                            style={styles.input}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item
                          label="AEPS Onboarding Charge"
                          style={styles.formItem}
                        >
                          <Input
                            type="number"
                            name="aeps_onBoardingCharge"
                            value={values.aeps_onBoardingCharge}
                            onChange={handleInputChange}
                            style={styles.input}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item
                          label="Min AEPS To Main Wallet"
                          style={styles.formItem}
                        >
                          <Input
                            type="number"
                            name="minAepsToMainWallet"
                            value={values.minAepsToMainWallet}
                            onChange={handleInputChange}
                            style={styles.input}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item
                          label="Courier Charges"
                          style={styles.formItem}
                        >
                          <Input
                            type="number"
                            name="courier_charges"
                            value={values.courier_charges}
                            onChange={handleInputChange}
                            style={styles.input}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item
                          label="Courier Order Charges (%)"
                          style={styles.formItem}
                        >
                          <Input
                            type="number"
                            name="courier_order_charges"
                            value={values.courier_order_charges}
                            onChange={handleInputChange}
                            style={styles.input}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item
                          label="Courier Cashback"
                          style={styles.formItem}
                        >
                          <Input
                            type="number"
                            name="courier_cashback"
                            value={values.courier_cashback}
                            onChange={handleInputChange}
                            style={styles.input}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Form.Item>
                      <Button
                        type="primary"
                        htmlType="submit"
                        disabled={
                          !values.bankVerificationCharge ||
                          !values.aeps_onBoardingCharge ||
                          !values.minAepsToMainWallet ||
                          !values.courier_charges ||
                          !values.courier_order_charges ||
                          !values.courier_cashback
                        }
                        style={{
                          ...styles.button,
                          ...(!values.bankVerificationCharge ||
                          !values.aeps_onBoardingCharge ||
                          !values.minAepsToMainWallet ||
                          !values.courier_charges ||
                          !values.courier_order_charges ||
                          !values.courier_cashback
                            ? styles.buttonDisabled
                            : {}),
                        }}
                      >
                        Update Charges
                      </Button>
                    </Form.Item>
                  </Form>
                )}
              </Formik>
            )}
          </Panel>

          <Panel
            header={<span style={styles.panelHeader}>DMT</span>}
            key="dmt"
            style={styles.panel}
          >
            <div style={styles.form}>
              <Row gutter={16}>
                <Col xs={24} lg={12}>
                  <Form.Item label="Select Bank" style={styles.formItem}>
                    <MultiSelect
                      options={dmtData.dmtOptions}
                      selectedIds={dmtData.dmtApiType}
                      setSelectedIds={(selected) =>
                        setDmtData((prevState) => ({
                          ...prevState,
                          dmtApiType: selected,
                        }))
                      }
                      setDefaultApi={(value) =>
                        setDmtData((prevState) => ({
                          ...prevState,
                          defaultApi: value,
                        }))
                      }
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} lg={12}>
                  <Form.Item label="SELECT DEFAULT API" style={styles.formItem}>
                    <Select
                      value={dmtData.defaultApi}
                      onChange={(value) =>
                        setDmtData((prevState) => ({
                          ...prevState,
                          defaultApi: value,
                        }))
                      }
                      style={styles.input}
                    >
                      {dmtData.dmtApiType.map((id) => {
                        const option = dmtData.dmtOptions.find(
                          (opt) => opt.id === id
                        );
                        return option ? (
                          <Option key={option.id} value={option.id}>
                            {`${option.label} (${option.value})`}
                          </Option>
                        ) : null;
                      })}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Button
                onClick={handleDmtUpdate}
                disabled={dmtData.dmtApiType.length === 0}
                style={{
                  ...styles.button,
                  ...(dmtData.dmtApiType.length === 0
                    ? styles.buttonDisabled
                    : {}),
                }}
              >
                Update DMT
              </Button>
            </div>
          </Panel>

          {/* <Panel
            header={<span style={styles.panelHeader}>Payout</span>}
            key="payout"
            style={styles.panel}
          >
            <div style={styles.form}>
              <Row gutter={16}>
                <Col xs={24} lg={12}>
                  <Form.Item label="Select Bank" style={styles.formItem}>
                    <MultiSelect
                      options={payoutData.payoutOptions}
                      selectedIds={payoutData.payoutApi}
                      setSelectedIds={(selected) =>
                        setPayoutData((prevState) => ({
                          ...prevState,
                          payoutApi: selected,
                        }))
                      }
                      setDefaultApi={(value) =>
                        setPayoutData((prevState) => ({
                          ...prevState,
                          defaultPayoutApi: value,
                        }))
                      }
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} lg={12}>
                  <Form.Item label="SELECT DEFAULT API" style={styles.formItem}>
                    <Select
                      value={payoutData.defaultPayoutApi}
                      onChange={(value) =>
                        setPayoutData((prevState) => ({
                          ...prevState,
                          defaultPayoutApi: value,
                        }))
                      }
                      style={styles.input}
                    >
                      {payoutData.payoutApi.map((id) => {
                        const option = payoutData.payoutOptions.find(
                          (opt) => opt.id === id
                        );
                        return option ? (
                          <Option key={option.id} value={option.id}>
                            {`${option.label} (${option.value})`}
                          </Option>
                        ) : null;
                      })}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Button
                onClick={handlePayoutUpdate}
                disabled={payoutData.payoutApi.length === 0}
                style={{
                  ...styles.button,
                  ...(payoutData.payoutApi.length === 0
                    ? styles.buttonDisabled
                    : {}),
                }}
              >
                Update Payout
              </Button>
            </div>
          </Panel> */}


           <Panel
            header={<span style={styles.panelHeader}>Payout Setting </span>}
            key="new_payout"
            style={styles.panel}
          >
            <section className="ListDistributer exppdf">
              <div className="row m-4">
                <div className="col-xl-12">
                  <div className="card">
                    <div className="card-body p-0">
                      <div className="table-responsive active-projects style-1">
                        <div className="tbl-caption pe-4">
                          <h4 className="heading mb-0">
                            <b>Payout Setting User List</b>
                          </h4>
                          <div className="d-flex">
                            <div>
                              <p
                                class="btn btn-primary mr-3"
                                onClick={() => setOpenPayoutModel(true)}
                              >
                                Add New Setting
                              </p>
                            </div>
                          </div>
                        </div>
                       {/* <div className="tbl-caption">
                          <h4 className="heading mb-0">
                            <b> Payout Setting List </b>
                          </h4>
                          <div></div>
                        </div> */}
                        <div
                          id="empoloyees-tblwrapper_wrapper"
                          className="dataTables_wrapper no-footer"
                        >
                          <table
                            id="table-to-xls"
                            className="table dataTable no-footer"
                            role="grid"
                            aria-describedby="empoloyees-tblwrapper_info"
                          >
                            <thead>
                              <tr role="row">
                                <th
                                  className="sorting_asc"
                                  tabIndex={0}
                                  aria-controls="empoloyees-tblwrapper"
                                  rowSpan={1}
                                  colSpan={1}
                                  aria-sort="ascending"
                                  aria-label="Employee ID: activate to sort column descending"
                                  style={{ width: "122.312px" }}
                                >
                                  Sr. No
                                </th>
                                <th
                                  className="sorting"
                                  tabIndex={0}
                                  aria-controls="empoloyees-tblwrapper"
                                  rowSpan={1}
                                  colSpan={1}
                                  aria-label="Status: activate to sort column ascending"
                                  style={{ width: "96.125px" }}
                                >
                                  User Name{" "}
                                </th>
                                 <th
                                  className="sorting"
                                  tabIndex={0}
                                  aria-controls="empoloyees-tblwrapper"
                                  rowSpan={1}
                                  colSpan={1}
                                  aria-label="Status: activate to sort column ascending"
                                  style={{ width: "96.125px" }}
                                >
                                  User Email{" "}
                                </th>
                                 <th
                                  className="sorting"
                                  tabIndex={0}
                                  aria-controls="empoloyees-tblwrapper"
                                  rowSpan={1}
                                  colSpan={1}
                                  aria-label="Status: activate to sort column ascending"
                                  style={{ width: "96.125px" }}
                                >
                                  User Mobile{" "}
                                </th>

                                <th
                                  className="sorting_asc"
                                  tabIndex={0}
                                  aria-controls="empoloyees-tblwrapper"
                                  rowSpan={1}
                                  colSpan={1}
                                  aria-sort="ascending"
                                  aria-label="Employee ID: activate to sort column descending"
                                  style={{ width: "122.312px" }}
                                >
                                   Vendor Name
                                </th>
                                 <th
                                  className="sorting"
                                  tabIndex={0}
                                  aria-controls="empoloyees-tblwrapper"
                                  rowSpan={1}
                                  colSpan={1}
                                  aria-label="Status: activate to sort column ascending"
                                  style={{ width: "96.125px" }}
                                >
                                  Vendor Slug{" "}
                                </th>
                                <th
                                  className="sorting_asc"
                                  tabIndex={0}
                                  aria-controls="empoloyees-tblwrapper"
                                  rowSpan={1}
                                  colSpan={1}
                                  aria-sort="ascending"
                                  aria-label="Employee ID: activate to sort column descending"
                                  style={{ width: "122.312px" }}
                                >
                                  Edit
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {payoutSettingList?.data?.map((item, i) => (
                                <tr key={item?._id}>
                                  <td>{i + 1 }</td>
                                  <td>{item?.user_name}</td>
                                  {/* <td>{ item?.vendorSlug ? item?.vendorSlug  + " " + ( item?.vendorName ) : 'Deactived'}</td> */}
                                  <td>
                                    {item?.user_email}
                                  </td>
                                   <td>
                                    {item?.user_mobile}
                                  </td>
                                   <td>
                                    {item?.vender_name}
                                  </td>
                                   <td>
                                    {item?.vender_slug}
                                  </td>

                                  <td
                                    onClick={() =>
                                      handleEditClick(
                                        item
                                      )
                                    }
                                  >
                                    <button className="btn btn-primary shadow btn-xs sharp">
                                      <i className="fa fa-pencil" />
                                    </button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>

                          <div
                            className="dataTables_info"
                            id="empoloyees-tblwrapper_info"
                            role="status"
                            aria-live="polite"
                          >
                            Total {payoutSettingList?.totalCount || 0} entries
                          </div>
                          <div
                            className="dataTables_paginate paging_simple_numbers"
                            id="empoloyees-tblwrapper_paginate"
                          >
                            <Pagination
                             
                              current={payoutSettingCurrentPage}
                              align="center"
                              onChange={(e) => setPayoutSettingCurrentPage(e)}
                            
                              total={payoutSettingList?.totalCount || 0}
                            />
                          </div>
                        </div>
                        </div>
                        </div>
                        </div>
                        </div>
                        </div>
                        </section>
                        </Panel>

          <Panel
            header={<span style={styles.panelHeader}>AEPS </span>}
            key="aeps2"
            style={styles.panel}
          >
            <div style={styles.form}>
              <Row gutter={[16, 16]}>
                <Col xs={24} lg={12}>
                  <Form.Item label="Select Bank" style={styles.formItem}>
                    <MultiSelect
                      options={aepsbank}
                      selectedIds={aepsbankselectedIds}
                      setSelectedIds={setAepsbankSelectedIds}
                      setDefaultApi={setAepsbankDefault}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} lg={12}>
                  <Form.Item
                    label="SELECT DEFAULT Bank"
                    style={styles.formItem}
                  >
                    <Select
                      value={aepsbankdefault}
                      onChange={(value) =>
                        setAepsbankDefault((prevState) => value)
                      }
                      style={styles.input}
                    >
                      {aepsbankselectedIds?.map((id) => {
                        const option = aepsbank?.find((opt) => opt.id === id);
                        return option ? (
                          <Option key={option.id} value={option.id}>
                            {`${option.label} (${option.value})`}
                          </Option>
                        ) : null;
                      })}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Button
                onClick={handlebankupdateStatus}
                // disabled={dmtData.dmtApiType.length === 0}
                style={{
                  ...styles.button,
                  // ...(dmtData.dmtApiType.length === 0 ? styles.buttonDisabled : {})
                }}
              >
                Update AEPS Bank
              </Button>
            </div>

            <div style={{ marginTop: "20px" }}></div>

            <div style={styles.form}>
              <Row gutter={[16, 16]}>
                {activeBankService?.length === 0 && (
                  <Col span={24}>
                    <Alert
                      message="No AEPS services available"
                      type="warning"
                      showIcon
                    />
                  </Col>
                )}
                {activeBankService?.some((api) => api.slug === "aeps1") && (
                  <Col xs={24} lg={16}>
                    <Form.Item
                      label="Select AEPS 1 Services"
                      style={styles.formItem}
                    >
                      <MultiSelect
                        options={SelectedIdAEPS2}
                        selectedIds={selectedIds}
                        setSelectedIds={setSelectedIds}
                        setDefaultApi={setDefaultApi}
                        valueShow={true}
                      />
                    </Form.Item>
                  </Col>
                )}
                {activeBankService?.some((api) => api.slug === "aeps2") && (
                  <Col xs={24} lg={16}>
                    <Form.Item
                      label="Select AEPS 2 Services"
                      style={styles.formItem}
                    >
                      <MultiSelect
                        options={SelectedIdAEPS4}
                        selectedIds={selectedIds4}
                        setSelectedIds={setSelectedIds4}
                        setDefaultApi={setDefaultApi4}
                        valueShow={true}
                      />
                    </Form.Item>
                  </Col>
                )}
              </Row>
              {activeBankService?.length != 0 && (
                <Button
                  onClick={handleUpdateAepsSetting}
                  disabled={
                    selectedIds4.length === 0 && selectedIds.length === 0
                  }
                  style={{
                    ...styles.button,
                    ...(selectedIds4.length === 0 && selectedIds.length === 0
                      ? styles.buttonDisabled
                      : {}),
                  }}
                >
                  Update AEPS Service
                </Button>
              )}
            </div>
          </Panel>

          <Panel
            header={<span style={styles.panelHeader}>BBPS </span>}
            key="bbps"
            style={styles.panel}
          >
            <section className="ListDistributer exppdf">
              <div className="row m-4">
                <div className="col-xl-12">
                  <div className="card">
                    <div className="card-body p-0">
                      <div className="table-responsive active-projects style-1">
                        <div className="tbl-caption pe-4">
                          <h4 className="heading mb-0">
                            <b>BBPS Service List</b>
                          </h4>
                          <div className="d-flex">
                            <div>
                              <p
                                class="btn btn-primary mr-3"
                                onClick={() => setOpenModel(true)}
                              >
                                Add Setting
                              </p>
                            </div>
                          </div>
                        </div>
                        {/* //filter start */}

                        <div className="row m-4">
                          <div className="col-xl-12">
                            <div className="card">
                              <div className="card-body p-0">
                                <div className="table-responsive active-projects style-1">
                                  <div className="tbl-caption tbl-caption-2">
                                    <h4 className="heading mb-0">
                                      <b>{"BBPS Setting Search"} </b>
                                    </h4>
                                  </div>
                                  <div className="row pt-2">
                                    <div className="col-md-4">
                                      <label>Service Name</label>
                                      <input
                                        type="text"
                                        name="service_name"
                                        value={bbpsSettingFilter.service_name}
                                        className="form-control"
                                        onChange={handleFilterChange}
                                      />
                                    </div>
                                    <div className="col-md-4">
                                      <label>Vendor Slug</label>
                                      <input
                                        type="text"
                                        name="vendor_slug"
                                        value={bbpsSettingFilter.vendor_slug}
                                        className="form-control"
                                        onChange={handleFilterChange}
                                      />
                                    </div>

                                    <div className="col-md-12 mt-3">
                                      <button
                                        className="btn btn-primary"
                                        onClick={applyFilter}
                                      >
                                        Submit
                                      </button>
                                      <button
                                        className="btn btn-info ml-3"
                                        onClick={handleReset}
                                      >
                                        Reset
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* {filter end} */}
                        <div className="tbl-caption">
                          <h4 className="heading mb-0">
                            <b> BBPS Setting List </b>
                          </h4>
                          <div></div>
                        </div>
                        <div
                          id="empoloyees-tblwrapper_wrapper"
                          className="dataTables_wrapper no-footer"
                        >
                          <table
                            id="table-to-xls"
                            className="table dataTable no-footer"
                            role="grid"
                            aria-describedby="empoloyees-tblwrapper_info"
                          >
                            <thead>
                              <tr role="row">
                                <th
                                  className="sorting_asc"
                                  tabIndex={0}
                                  aria-controls="empoloyees-tblwrapper"
                                  rowSpan={1}
                                  colSpan={1}
                                  aria-sort="ascending"
                                  aria-label="Employee ID: activate to sort column descending"
                                  style={{ width: "122.312px" }}
                                >
                                  Sr. No
                                </th>
                                <th
                                  className="sorting"
                                  tabIndex={0}
                                  aria-controls="empoloyees-tblwrapper"
                                  rowSpan={1}
                                  colSpan={1}
                                  aria-label="Status: activate to sort column ascending"
                                  style={{ width: "96.125px" }}
                                >
                                  Service Name{" "}
                                </th>

                                <th
                                  className="sorting_asc"
                                  tabIndex={0}
                                  aria-controls="empoloyees-tblwrapper"
                                  rowSpan={1}
                                  colSpan={1}
                                  aria-sort="ascending"
                                  aria-label="Employee ID: activate to sort column descending"
                                  style={{ width: "122.312px" }}
                                >
                                  Active Vendor
                                </th>
                                <th
                                  className="sorting_asc"
                                  tabIndex={0}
                                  aria-controls="empoloyees-tblwrapper"
                                  rowSpan={1}
                                  colSpan={1}
                                  aria-sort="ascending"
                                  aria-label="Employee ID: activate to sort column descending"
                                  style={{ width: "122.312px" }}
                                >
                                  Edit
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {bbpsListData?.data?.map((item, i) => (
                                <tr key={item?._id}>
                                  <td>{i + 1 + bbpsPage * 10}</td>
                                  <td>{item?.service_name}</td>
                                  {/* <td>{ item?.vendorSlug ? item?.vendorSlug  + " " + ( item?.vendorName ) : 'Deactived'}</td> */}
                                  <td>
                                    {item?.vendorSlug && item?.vendorName
                                      ? `${item.vendorSlug} (${item.vendorName})`
                                      : "Deactivated"}
                                  </td>

                                  <td
                                    onClick={() =>
                                      handleClickBBPSEdit(
                                        item?._id,
                                        item?.service_id,
                                        item?.vendorId
                                      )
                                    }
                                  >
                                    <button className="btn btn-primary shadow btn-xs sharp">
                                      <i className="fa fa-pencil" />
                                    </button>
                               
                                    {/* <select name="vendor"
                  value={item?.vendorId === null ? 'null' : item?.vendorId} 
                  onChange={(e)=>hanldeBBPSsettingupdate(e , item?._id)}  style={{width:'150px'}}>
                  <option value={'null'}>{'None'}</option>
                    {item?.active_vendors?.map((vendor)=>
                      <option value={vendor?._id}>{vendor?.slug + " " + (vendor?.name)}</option>
                    )}
  

  </select> */}
                                    {/* <div>
  <label style={{ marginRight: '10px' }}>
    <input
      type="radio"
      name="vendor"
      value=""
      checked={item?.vendorId === ""}
      onChange={(e) => hanldeBBPSsettingupdate(e, item?._id)}
    />
    None
  </label>

  {item?.active_vendors?.map((vendor) => (
    <label key={vendor?._id} style={{ marginRight: '10px' }}>
      <input
        type="radio"
        name="vendor"
        value={vendor?._id}
        checked={item?.vendorId === vendor?._id}
        onChange={(e) => hanldeBBPSsettingupdate(e, item?._id)}
      />
      {vendor?.slug + " " + (vendor?.name)}
    </label>
  ))}
</div> */}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>

                          <div
                            className="dataTables_info"
                            id="empoloyees-tblwrapper_info"
                            role="status"
                            aria-live="polite"
                          >
                            Total {bbpsListData?.totalCount} entries
                          </div>
                          <div
                            className="dataTables_paginate paging_simple_numbers"
                            id="empoloyees-tblwrapper_paginate"
                          >
                            <Pagination
                              /* showSizeChanger
                                                onShowSizeChange={''} */

                              // defaultCurrent={1}
                              current={bbpsPage + 1}
                              align="center"
                              onChange={(e) => setBbpsPage(e - 1)}
                              // onChange={onChangeVal}
                              total={bbpsListData?.totalCount}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </Panel>

          <Panel
            header={<span style={styles.panelHeader}>Courier</span>}
            key="courier"
            style={styles.panel}
          >
            <section className="ListDistributer exppdf">
              <div className="row m-4">
                <div className="col-xl-12">
                  <div className="card">
                    <div className="card-body p-0">
                      <div className="table-responsive active-projects style-1">
                        <div className="tbl-caption pe-4">
                          <h4 className="heading mb-0">
                            {/* <b>Courier Service List</b> */}
                          </h4>
                          <div className="d-flex">
                            <div>
                              <p
                                class="btn btn-primary mr-3"
                                onClick={() => setOpencourierSetting(true)}
                              >
                                Add Courier Setting
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="tbl-caption">
                      <h4 className="heading mb-0">
                        <b> Courier Setting List </b>
                      </h4>
                      <div></div>
                    </div>
                    <div
                      id="empoloyees-tblwrapper_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <table
                        id="table-to-xls"
                        className="table dataTable no-footer"
                        role="grid"
                        aria-describedby="empoloyees-tblwrapper_info"
                      >
                        <thead>
                          <tr role="row">
                            <th
                              className="sorting_asc"
                              tabIndex={0}
                              aria-controls="empoloyees-tblwrapper"
                              rowSpan={1}
                              colSpan={1}
                              aria-sort="ascending"
                              aria-label="Employee ID: activate to sort column descending"
                              style={{ width: "50.312px" }}
                            >
                              Sr. No
                            </th>
                            <th
                              className="sorting"
                              tabIndex={0}
                              aria-controls="empoloyees-tblwrapper"
                              rowSpan={1}
                              colSpan={1}
                              aria-label="Status: activate to sort column ascending"
                              style={{ width: "96.125px" }}
                            >
                              Vendor Name{" "}
                            </th>
                            <th
                              className="sorting"
                              tabIndex={0}
                              aria-controls="empoloyees-tblwrapper"
                              rowSpan={1}
                              colSpan={1}
                              aria-label="Status: activate to sort column ascending"
                              style={{ width: "96.125px" }}
                            >
                              Vendor Slug{" "}
                            </th>
                            <th
                              className="sorting_asc"
                              tabIndex={0}
                              aria-controls="empoloyees-tblwrapper"
                              rowSpan={1}
                              colSpan={1}
                              aria-sort="ascending"
                              aria-label="Employee ID: activate to sort column descending"
                              style={{ width: "122.312px" }}
                            >
                              Active 
                            </th>
                            <th
                              className="sorting_asc"
                              tabIndex={0}
                              aria-controls="empoloyees-tblwrapper"
                              rowSpan={1}
                              colSpan={1}
                              aria-sort="ascending"
                              aria-label="Employee ID: activate to sort column descending"
                              style={{ width: "122.312px" }}
                            >
                              is Default
                            </th>
                            <th
                              className="sorting_asc"
                              tabIndex={0}
                              aria-controls="empoloyees-tblwrapper"
                              rowSpan={1}
                              colSpan={1}
                              aria-sort="ascending"
                              aria-label="Employee ID: activate to sort column descending"
                              style={{ width: "122.312px" }}
                            >
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {courierSettingListData?.map((item , i)=>
                          <tr>
                            <td>{i+1}</td>
                            <td>{item?.vendor}</td>
                            <td>{item?.slug}</td>
                            <td>{item?.status}</td>
                            <td>{item?.is_default ? 'True':"False"}</td>
                            <td >


                          
                            <button onClick={() => {
    setOpencourierSetting(true)
    setcourierSettingEditClick(true)
    setselectedCourierObj(item)
    setcourierSetting({
        vendor: item?.vendor,
        slug: item?.slug,
        status:item?.status,
        is_default : item?.is_default,
    });
}} className="btn btn-primary shadow btn-xs sharp">
                                      <i className="fa fa-pencil" />
                                    </button>

                                    <Popconfirm
                                  title="Delete"
                                  description="Are you sure to Delete ?"
                                  onConfirm={()=>handleDeleteCourierSetting(item)}
                                  onCancel={()=>{}}
                                  okText="Yes"
                                  cancelText="No"
                                  >
 <button className="btn btn-primary shadow btn-xs sharp">
                                      {/* <i className="fa fa-pencil" /> */}
                                      <i className="fa fa-trash" />
                                    
                                    </button>
                                  </Popconfirm>
                                    </td>

                                 
                          </tr>
                          )}
                      
                        </tbody>
                      </table>

                      {/* <div className="dataTables_info" id="empoloyees-tblwrapper_info" role="status" aria-live="polite">
                                            Total {bbpsListData?.totalCount} entries
                                        </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </Panel>

          {openModel && (
            <Modal
              show={openModel}
              onHide={handleBBpsSettingPopupClose}
              centered
              className="pkg-congrats-modal"
            >
              <Modal.Body
                style={{ backgroundColor: "#fff" }}
                className="pkg-congrats-modal__body"
              >
                <button
                  style={{ color: "#000000" }}
                  className="pkg-congrats-modal__close"
                  onClick={handleBBpsSettingPopupClose}
                >
                  ×
                </button>
                <Row gutter={[16, 16]} className="mt-2">
                  <Col xs={24} lg={24}>
                    <Form.Item label="Select Service" style={styles.formItem}>
                      <Select
                        value={selectedBBPSService}
                        onChange={handleSelectService}
                        style={styles.input}
                        getPopupContainer={(triggerNode) =>
                          triggerNode.parentNode
                        }
                      >
                        <Option value={""} disabled>
                          {`Select Service Name`}
                        </Option>
                        {bbpsSettingList?.map((item) => (
                          <Option key={item._id} value={item?._id}>
                            {` ${item?.service_name}`}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col xs={24} lg={24}>
                    <Form.Item label="Select Vendor" style={styles.formItem}>
                      <Select
                        value={selectedBBPSVendor}
                        onChange={(value) => setSelectedBBPSVendor(value)}
                        style={styles.input}
                        getPopupContainer={(triggerNode) =>
                          triggerNode.parentNode
                        }
                      >
                        <Option value={""} disabled>
                          {`Select Vendor Name`}
                        </Option>
                        {selectedServiceforVendor?.vendor?.map((item) => (
                          <Option key={item._id} value={item?._id}>
                            {`${item?.name}  (${item?.slug})`}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <button
                    className="btn btn-primary"
                    disabled={!(selectedBBPSService && selectedBBPSVendor)}
                    onClick={hanldeBBPSsettingAddEdit}
                  >
                    {bbpsSettingEditClick ? "Update List" : "Add List"}
                  </button>
                </Row>
              </Modal.Body>
            </Modal>
          )}



{opencourierSetting && (
            <Modal
              show={opencourierSetting}
              onHide={handleCourierSettingPopupClose}
              centered
              className="pkg-congrats-modal"
            >
              <Modal.Body
                style={{ backgroundColor: "#fff" }}
                className="pkg-congrats-modal__body"
              >
                <button
                  style={{ color: "#000000" }}
                  className="pkg-congrats-modal__close"
                  onClick={handleCourierSettingPopupClose}
                >
                  ×
                </button>
                <Row gutter={[16, 16]} className="mt-2">
               
                                    <div className="col-12">
                                      <label>Vendor</label>
                                      <input
                                        type="text"
                                        name="vendor"
                                        value={addcourierSetting.vendor}
                                        className="form-control"
                                        onChange={handleaddCourierSetting}
                                      />
                                    </div>
                                    <div className="col-12">
                                      <label>Slug</label>
                                      <input
                                        type="text"
                                        name="slug"
                                        value={addcourierSetting.slug}
                                        disabled={courierSettingEditClick}
                                        className="form-control"
                                        onChange={handleaddCourierSetting}
                                      />
                                    </div>
                      {courierSettingEditClick && 
                      <>
                    
                                    <div className="col-12">
  <label>Status</label>
  <select
    name="status"
    value={addcourierSetting.status}
    className="form-control"
    onChange={handleaddCourierSetting}
  >
    <option value="">Select status</option>
    <option value="Active">Active</option>
    <option value="Block">Block</option>
  </select>
</div>

<div className="col-12 form-check mt-2">
  <input
    type="checkbox"
    name="is_default"
    checked={addcourierSetting.is_default}
    className="form-check-input mt-2"
    onChange={(e) =>
      handleaddCourierSetting({
        target: {
          name: 'is_default',
          value: e.target.checked,
        },
      })
    }
  />
  <label className="form-check-label">Set as Default</label>
</div>   </>}
                  <button
                    className="btn btn-primary"
                    // disabled={!(selectedBBPSService && selectedBBPSVendor)}
                    onClick={hanldeCouriersettingAddEdit}
                  >
                    {courierSettingEditClick ? "Update Setting" : "Add Setting"}
                   
                  </button>
                </Row>
              </Modal.Body>
            </Modal>
          )}



          {openPayoutModel && (
              <Modal
                    show={openPayoutModel}
              onHide={handleClosePayoutModel}
              centered
              className="pkg-congrats-modal"
                  
                  
                >
  <Modal.Body
                style={{ backgroundColor: "#fff" }}
                className="pkg-congrats-modal__body"
              >
                <button
                  style={{ color: "#000000" }}
                  className="pkg-congrats-modal__close"
                  onClick={handleClosePayoutModel}
                >
                  ×
                </button>
        <Form form={payoutForm} layout="vertical">
  <Row gutter={[16, 16]} className="mt-2">
     <Col xs={24} lg={24}>
      <Form.Item
        name="user_name"
        label="Select User"
        rules={[{ required: true, message: 'Please select a user' }]}
        className="mb-2"
      >
        <Select
          showSearch
          placeholder="Search and select a user"
          optionFilterProp="children"
          disabled={currentSelectedpayoutList}
          onChange={(value) => {
            setSelectedPayoutUser(value);
            payoutForm.setFieldsValue({ user_name: value });
          }}
          getPopupContainer={(triggerNode) => triggerNode.parentNode}
          filterOption={(input, option) =>
            option.children.toLowerCase().includes(input.toLowerCase())
          }
        >
          <Option value="" disabled>Select User</Option>
          {payoutUserList?.map((item) => (
            <Option key={item._id} value={item._id}>
              {item.name}
            </Option>
          ))}
        </Select>
      </Form.Item>
    </Col>
    <Col xs={24} lg={24}>
      <Form.Item
        name="vendor_name"
        label="Select Vendor"
        rules={[{ required: true, message: 'Please select a vendor' }]}
        
      >
        <Select
          showSearch
          placeholder="Search and select a vendor"
          optionFilterProp="children"
          onChange={(value) => {
            setSelectedPayoutVendor(value);
            payoutForm.setFieldsValue({ vendor_name: value });
          }}
          getPopupContainer={(triggerNode) => triggerNode.parentNode}
          filterOption={(input, option) =>
            option.children.toLowerCase().includes(input.toLowerCase())
          }
        >
          <Option value="" disabled>Select Vendor Name</Option>
          {payoutVendorList?.map((item) => (
            <Option key={item._id} value={item._id}>
              {`${item.vender_name} (${item.slug})`}
            </Option>
          ))}
        </Select>
      </Form.Item>
    </Col>

   

    <Col span={24}>
      <button
        className="btn btn-primary"
        disabled={!(selectedPayoutUser && selectedPayoutVendor)}
        onClick={handleAddUpdatePayoutSetting}
      >
        {currentSelectedpayoutList ? "Update Setting" : "Add New Setting"}
      </button>
    </Col>
  </Row>
</Form>

                </Modal.Body>
                </Modal>
          )}

          {/* <Panel header={<span style={styles.panelHeader}>AEPS </span>} key="apes2" style={styles.panel}>
          <div style={styles.form}>
            <Row gutter={16}>
              <Col xs={24} lg={24}>
              
              <div style={{ maxWidth: "900px", margin: "auto", padding: "20px" }}>
      <Title level={4} style={{ textAlign: "center", marginBottom: "20px" }}>
        Bank Service Selection
      </Title>

      <Row gutter={[16, 16]} justify="center">
        {banks.map((bank) => (
          <Col key={bank.id} xs={24} lg={12}>
            <Card
              title={<Title level={4} style={{ margin: 0 }}>{bank.name}</Title>}
              bordered={true}
              style={{
                borderRadius: "10px",
                boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)",
                height: "320px",
              }}
            >
              <Checkbox
                onChange={(e) => handleSelectAll(bank.id, e.target.checked)}
                checked={bank.services.every((service) => selectedValues[bank.id]?.[service] === "yes")}
              >
                <Text strong>Select All</Text>
              </Checkbox>

              <Divider />

              {bank.services.map((service) => (
                <Row key={service} align="middle" style={{ marginBottom: "10px" }}>
                  <Col span={12}>
                    <Text>{service}</Text>
                  </Col>
                  <Col span={6}>
                    <Checkbox
                      checked={selectedValues[bank.id]?.[service] === "yes"}
                      onChange={(e) => handleServiceChange(bank.id, service, e.target.checked)}
                    />
                  </Col>
                </Row>
              ))}
            </Card>
          </Col>
        ))}
      </Row>
    </div>
              </Col>
           
            </Row>
            <Button 
              
              // onClick={handleDmtUpdate} 
              // disabled={dmtData.dmtApiType.length === 0}
              style={{
                ...styles.button,
                marginTop:'20px',
                ...(dmtData.dmtApiType.length === 0 ? styles.buttonDisabled : {})
              }}
            >
              Update AEPS Settings
            </Button>
          </div>
        </Panel>   */}

          {/* <Panel header={<span style={styles.panelHeader}>AEPS</span>} key="aeps" style={styles.panel}> */}
          {/* <div style={styles.form}>
            <Form.Item label="AEPS On Boarding Default Bank" style={styles.formItem}>
              <Select
                value={aepsData.aeps_onBoardingDefaultBank}
                onChange={(value) => setAepsData(prevState => ({ ...prevState, aeps_onBoardingDefaultBank: value }))}
                style={styles.input}
              >
                <Option value="bank1">BANK 1</Option>
                <Option value="bank2">BANK 2</Option>
               
              </Select>
            </Form.Item>
            <Button 
              onClick={handleAepsUpdate}
              style={styles.button}
            >
              Update AEPS
            </Button>
          </div> */}
          {/* <AEPSSettings/> */}
          {/* </Panel> */}
        </Collapse>
        <ToastContainer />
      </div>
    </>
  );
}

export default ChargeSettings;
